import React, { Component } from 'react';
import Card from '../../components/Card';
import OCT from '../../components/OCT';
import Row from '../../components/Row';
import Select from '../../components/Select';
import { observer } from 'mobx-react';
import patient from '../../stores/patient';
import Header from '../../components/Header';
import Input from "../../components/Input";

@observer
class OCTForm extends Component {
	render() {
		return (
			<Card>
				<Card.Pad>
					<Row>
						<Row.Cell centered flexCol>
							<Header str="Right Eye" />
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Top</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octRightS" value={patient.fields.octRightS} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Right</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octRightN" value={patient.fields.octRightN} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Bottom</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octRightI" value={patient.fields.octRightI} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Left</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octRightT" value={patient.fields.octRightT} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<OCT eye="right" />
						</Row.Cell>
						<Row.Cell centered flexCol>
							<Header str="Left Eye" />
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Top</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octLeftS" value={patient.fields.octLeftS} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Right</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octLeftN" value={patient.fields.octLeftN} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Bottom</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octLeftI" value={patient.fields.octLeftI} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<Row smallMargin alignCenter>
								<Row.Cell flex="1" centered>Left</Row.Cell>
								<Row.Cell flex="5">
									<Select name="octLeftT" value={patient.fields.octLeftT} onChange={patient.setField}>
										<Select.Options choices="oct" />
									</Select>
								</Row.Cell>
							</Row>
							<OCT eye="left" />
						</Row.Cell>
						<Input
							label="titles.date"
							name={`octDate`}
							value={patient.fields[`octDate`] || ''}
							onChange={patient.setField}
						/>
					</Row>
				</Card.Pad>
			</Card>
		);
	}
}

export default OCTForm;



// WEBPACK FOOTER //
// ./src/pages/EditPatient/OCTForm.js